export const activities = [
  {
    id: "dance-music",
    title: "Dance and Music",
    iconName: "Music",
    color: "#FDE8E9",
    iconColor: "#C8161D",
    desc: "Rhythm, melody, and physical movement to introduce children to musical coordination, self-expression, and joy."
  },
  {
    id: "art-craft",
    title: "Art and Craft",
    iconName: "Palette",
    color: "#FCE7F3",
    iconColor: "#DB2777",
    desc: "Painting, sketching, folding, and sculpting to build fine motor skills, spatial coordination, and creative imagination."
  },
  {
    id: "yoga-mindfulness",
    title: "Yoga and Mindfulness",
    iconName: "Smile",
    color: "#F3F9E2",
    iconColor: "#9DC41E",
    desc: "Simple stretches, breathing exercises, and sensory mindfulness to support emotional calmness, focus, and health."
  },
  {
    id: "storytelling",
    title: "Storytelling Sessions",
    iconName: "BookOpen",
    color: "#E0F2FE",
    iconColor: "#0284c7",
    desc: "Interactive reading and listening sessions to spark imagination, linguistic vocabulary, and moral value building."
  },
  {
    id: "fancy-dress",
    title: "Fancy Dress & Role Play",
    iconName: "Mask", // will map to Lucide icon or fallback
    iconNameFallback: "Drama", 
    color: "#FEF9C3",
    iconColor: "#ca8a04",
    desc: "Theme-based dressing and character play to encourage speaking confidence, empathy, and emotional growth."
  },
  {
    id: "nature-walks",
    title: "Nature Walks & Environment",
    iconName: "Leaf",
    color: "#F0FFF4",
    iconColor: "#16A34A",
    desc: "Guided outdoor walks to explore plants, flowers, insects, and build early environmental care and observation skills."
  },
  {
    id: "sports-activities",
    title: "Sports and Outdoor Play",
    iconName: "Dumbbell",
    color: "#E0F2FE",
    iconColor: "#0284c7",
    desc: "Run, jump, throw, and balance activities on our safe play equipment to strengthen coordination and physical fitness."
  },
  {
    id: "science-fun",
    title: "Science Fun & STEAM",
    iconName: "Lightbulb",
    color: "#F3F9E2",
    iconColor: "#9DC41E",
    desc: "Simple child-safe experiments and structural building blocks to spark logic, inquiry, and early scientific curiosity."
  },
  {
    id: "cooking-no-fire",
    title: "Cooking Without Fire",
    iconName: "FlameKindling", // fallback to Utensils
    iconNameFallback: "Utensils",
    color: "#FEF9C3",
    iconColor: "#ca8a04",
    desc: "Safe fruit-mixing, sandwich-making, and salad preparation to teach basic math, shapes, and healthy eating habits."
  }
];

export const specialEvents = [
  { name: "Annual Day", desc: "A grand stage celebration where every child showcases their talent, building confidence and teamwork." },
  { name: "Sports Day", desc: "Joyful races and physical challenges focused on participation, active play, and sportsmanship." },
  { name: "Grandparents Day", desc: "A heartwarming occasion to welcome grandparents and honor their role in our children's lives." },
  { name: "Teachers' Day", desc: "Expressing gratitude and respect for our dedicated educators who guide our little learners." },
  { name: "Children's Day", desc: "A fun-filled day of games, special performances, and treats dedicated entirely to our students." },
  { name: "Independence & Republic Day", desc: "Celebrating national values and learning about community and unity through patriotic activities." },
  { name: "Christmas Celebration", desc: "Joyful carols, decorations, and shared kindness to celebrate the winter season of giving." },
  { name: "Graduation Ceremony", desc: "Marking a proud milestone as our Kindergarten graduates prepare for primary school with confidence." },
  { name: "Summer Camp", desc: "Exciting seasonal camps covering arts, music, sports, STEAM, and creative skills." }
];
